import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { DebouncedSearchBar } from '@confluence/debounced-search-bar';

export const messages = defineMessages({
	searchBarLabel: {
		id: 'snippets.panel.search.label',
		defaultMessage: 'Search Block Templates',
		description: 'A visible label for the search bar that allows the user to filter Snippets',
	},
	searchSnippetsPlaceholderText: {
		id: 'snippets.panel.search.placeholderText',
		defaultMessage: 'Search author, category, topic',
		description: 'The placeholder text in the templates search box, visible when it is empty',
	},
});

export const SnippetsPanelSearchBar = ({ onChange }: { onChange: (value: string) => void }) => {
	const intl = useIntl();
	return (
		<DebouncedSearchBar
			label={intl.formatMessage(messages.searchBarLabel)}
			placeholder={intl.formatMessage(messages.searchSnippetsPlaceholderText)}
			isCompact
			onChange={onChange}
		/>
	);
};
